import React, { useContext } from 'react';
import * as yup from 'yup';
import PropTypes from 'prop-types';
import FieldsWrapper, { defaultFields } from '../FieldsWrapper/FieldsWrapper';
import { TabsContext } from '../NewOrder';
import { isRequiredMsg } from '../../../../../../../../utils/format';
import { enforceMinTokensField, appendEnforceMinTokens } from '../LimitBuy/LimitBuy';

const fields = (fieldsState) => [
  ...defaultFields({
    ...fieldsState,
    label: 'common.sale_amount_src',
    infoHint: 'Select the amount of tokens you wish to sell',
  }),
  enforceMinTokensField({
    textFieldProps: { renderValue: (value) => `$${value}` },
    infoHint:
      'The minimum value in USD added to the pool after the trade is executed. The pool will receive this amount in WBNB',
  }),
];
export default function LimitSell({ type }) {
  const { hordUsdPrice } = useContext(TabsContext);

  const validationSchema = {
    price_usd: yup.number().min(hordUsdPrice, `Min is ${hordUsdPrice}`).required().typeError(isRequiredMsg('Price')),
  };
  return (
    <FieldsWrapper
      initialValues={{ slippage: 2.5 }}
      onValuesChanges={appendEnforceMinTokens}
      fields={fields}
      type={type}
      submitText="hpool.trade_orders_sell_limit"
    />
  );
}

LimitSell.propTypes = {
  type: PropTypes.string.isRequired,
};
